import { CandidateData } from '../../../../types/candidates';

const filterByAnySkill = (
  singleCandidate: CandidateData,
  searchedSkills: string[]
) => {
  return (
    (singleCandidate.CandidateSkills &&
      searchedSkills.some((searchedSKill: string) => {
        return singleCandidate?.CandidateSkills?.some((skillItem) => {
          return (
            skillItem?.Skill &&
            skillItem?.Skill?.Title &&
            skillItem?.Skill?.Title?.toLowerCase()?.includes(
              searchedSKill.toLowerCase()
            )
          );
        });
      })) ??
    false
  );
};

export default filterByAnySkill;
